export default __webpack_public_path__ + "static/Artboard-3-3bf8f8ae105a33253475b131e812ef68.webp";